import { TypeExpertise } from './type-expertise';
import { User } from './user';
  import { Collaborateur } from './collaborateur';
import { Contact } from './contact';
import * as moment from 'moment';

export class ExpertiseLight {

  public loading: boolean;
  public uidUpdate: number = 1;
  

	public id: number;
	public number: number;
	public name: string;
  
  	constructor(
  	) {}

    get publicIdentity(): string {
      return this.number + " " + this.name;
    }

}
